import {
  FührerscheinKlassen,
  FührerscheinKlassenSuper,
  JaNein,
  VorauswahlFreiwillig,
} from "@/models/enums";

export const dayJsDayToText = (day) => {
  switch (day) {
    case 0:
      return "Sonntag";
    case 1:
      return "Montag";
    case 2:
      return "Dienstag";
    case 3:
      return "Mittwoch";
    case 4:
      return "Donnerstag";
    case 5:
      return "Freitag";
    case 6:
      return "Samstag";
    default:
      return "err"; // should never happen
  }
};

export const dayJsDayToShortText = (day) => {
  switch (day) {
    case 0:
      return "So";
    case 1:
      return "Mo";
    case 2:
      return "Di";
    case 3:
      return "Mi";
    case 4:
      return "Do";
    case 5:
      return "Fr";
    case 6:
      return "Sa";
    default:
      return "err"; // should never happen
  }
};

export const dayJsMonthToText = (month) => {
  switch (month) {
    case 0:
      return "Januar";
    case 1:
      return "Februar";
    case 2:
      return "März";
    case 3:
      return "April";
    case 4:
      return "Mai";
    case 5:
      return "Juni";
    case 6:
      return "Juli";
    case 7:
      return "August";
    case 8:
      return "September";
    case 9:
      return "Oktober";
    case 10:
      return "November";
    case 11:
      return "Dezember";
    default:
      return "err"; // should never happen
  }
};

export const resolveClassCategory = (classCategory) => {
  switch (classCategory) {
    case FührerscheinKlassenSuper.A:
      return "Motorrad";
    case FührerscheinKlassenSuper.B:
      return "Auto";
    case FührerscheinKlassenSuper.C:
      return "LKW";
    case FührerscheinKlassenSuper.E:
      return "Anhänger";
    case FührerscheinKlassenSuper.F:
      return "Traktor";
    case FührerscheinKlassenSuper.AM:
      return "Moped";
    case FührerscheinKlassenSuper.KEINKURS_CODE111:
      return FührerscheinKlassen.CODE111;
    case FührerscheinKlassenSuper.KEINKURS_EZUBWENNF:
      return FührerscheinKlassen.EZUBWENNF;
    case FührerscheinKlassenSuper.BE:
    default:
      return classCategory;
  }
};

export function stateToPayloadCourse(state) {
  const classes = state.newDriverLicenceClasses.map((element) => {
    return convertClassToValidValue(element);
  });

  const courses = Object.values(state.selectedCourses).map((element) => {
    return element.id;
  });

  return {
    firstname: state.pi.firstname,
    lastname: state.pi.lastname,
    birthday: state.pi.birthdate,
    street: state.pi.street,
    house_number: state.pi.housenumber,
    postcode: state.pi.postalcode,
    city: state.pi.city,
    country: state.pi.country,
    citizenship: state.pi.citizenship,
    email: state.pi.email,
    phone: state.pi.phone,
    classes: classes,
    courses: courses,
  };
}

export function stateToPayloadTraining(state) {
  return {
    firstname: state.pi.firstname,
    lastname: state.pi.lastname,
    birthday: state.pi.birthdate,
    street: state.pi.street,
    house_number: state.pi.housenumber,
    postcode: state.pi.postalcode,
    city: state.pi.city,
    country: state.pi.country,
    citizenship: state.pi.citizenship,
    email: state.pi.email,
    phone: state.pi.phone,
    rent_vehicle: state.borrowVehicle == JaNein.JA ? true : false,
    training_id: state.selectedTraining.id,
    training_forced:
      state.preInterestFreiwillig == VorauswahlFreiwillig.JA ? false : true,
    class: state.selectedVehicletype,
    affiliate_id: state.ref ? state.ref : null,
  };
}

export function convertClassToValidValue(classs) {
  switch (classs) {
    case FührerscheinKlassen.A:
      return "A";
    case FührerscheinKlassen.A1:
      return "A1";
    case FührerscheinKlassen.A2:
      return "A2";
    case FührerscheinKlassen.CODE111:
      return "Code111";
    case FührerscheinKlassen.AM:
      return "AM";
    case FührerscheinKlassen.B:
      return "B";
    case FührerscheinKlassen.BDUAL:
      return "BL";
    case FührerscheinKlassen.BL17:
      return "BV";
    case FührerscheinKlassen.C:
      return "C";
    case FührerscheinKlassen.C1:
      return "C1";
    case FührerscheinKlassen.CE:
      return "CE";
    case FührerscheinKlassen.EZUB:
      return "BE";
    case FührerscheinKlassen.EZUC:
      return "CE";
    case FührerscheinKlassen.EZUBWENNF:
      return "BE";
    case FührerscheinKlassen.CODE96:
      return "Code96";
    case FührerscheinKlassen.F:
      return "F";
  }
}

export function mapDriverLicnceClassesSuper(driverLicenceClass) {
  switch (driverLicenceClass) {
    case FührerscheinKlassen.A:
    case FührerscheinKlassen.A1:
    case FührerscheinKlassen.A2:
      return FührerscheinKlassenSuper.A;
    case FührerscheinKlassen.CODE111:
      return FührerscheinKlassenSuper.KEINKURS_CODE111;
    case FührerscheinKlassen.AM:
      return FührerscheinKlassenSuper.AM;
    case FührerscheinKlassen.B:
    case FührerscheinKlassen.BDUAL:
    case FührerscheinKlassen.BL17:
      return FührerscheinKlassenSuper.B;
    case FührerscheinKlassen.C:
    case FührerscheinKlassen.C1:
    case FührerscheinKlassen.CE:
    case FührerscheinKlassen.EZUC:
      return FührerscheinKlassenSuper.C;
    case FührerscheinKlassen.EZUB:
    case FührerscheinKlassen.CODE96:
      return FührerscheinKlassenSuper.BE;
    case FührerscheinKlassen.EZUBWENNF:
      return FührerscheinKlassenSuper.KEINKURS_EZUBWENNF;
    case FührerscheinKlassen.F:
      return FührerscheinKlassenSuper.F;
  }
  return null;
}

export function getCountryNameByCode(code) {
  switch (code) {
    case "AUT":
      return "Österreich";
    case "AFG":
      return "Afghanistan";
    case "EGY":
      return "Ägypten";
    case "ALB":
      return "Albanien";
    case "DZA":
      return "Algerien";
    case "AND":
      return "Andorra";
    case "AGO":
      return "Angola";
    case "ATG":
      return "Antigua und Barbuda";
    case "GNQ":
      return "Äquatorialguinea";
    case "ARG":
      return "Argentinien";
    case "ARM":
      return "Armenien";
    case "AZE":
      return "Aserbaidschan";
    case "ETH":
      return "Äthiopien";
    case "AUS":
      return "Australien";
    case "BHS":
      return "Bahamas";
    case "BHR":
      return "Bahrain";
    case "BGD":
      return "Bangladesch";
    case "BRB":
      return "Barbados";
    case "BEL":
      return "Belgien";
    case "BLZ":
      return "Belize";
    case "BEN":
      return "Benin";
    case "BTN":
      return "Bhutan";
    case "BOL":
      return "Bolivien";
    case "BIH":
      return "Bosnien Herzegowina";
    case "BWA":
      return "Botsuana";
    case "BRA":
      return "Brasilien";
    case "BRN":
      return "Brunei Darussalam";
    case "BGR":
      return "Bulgarien";
    case "BFA":
      return "Burkina Faso";
    case "BDI":
      return "Burundi";
    case "CHL":
      return "Chile";
    case "CHN":
      return "China";
    case "CRI":
      return "Costa Rica";
    case "CIV":
      return "Côte d'Ivoire";
    case "DNK":
      return "Dänemark";
    case "DEU":
      return "Deutschland";
    case "DMA":
      return "Dominica";
    case "DOM":
      return "Dominikanische Republik";
    case "DJI":
      return "Dschibuti";
    case "ECU":
      return "Ecuador";
    case "SLV":
      return "El Salvador";
    case "ERI":
      return "Eritrea";
    case "EST":
      return "Estland";
    case "FJI":
      return "Fidschi";
    case "FIN":
      return "Finnland";
    case "FRA":
      return "Frankreich";
    case "GAB":
      return "Gabun";
    case "GMB":
      return "Gambia";
    case "GEO":
      return "Georgien";
    case "GHA":
      return "Ghana";
    case "GRD":
      return "Grenada";
    case "GRC":
      return "Griechenland";
    case "GTM":
      return "Guatemala";
    case "GIN":
      return "Guinea";
    case "GNB":
      return "Guinea-Bissau";
    case "GUY":
      return "Guyana";
    case "HTI":
      return "Haiti";
    case "HND":
      return "Honduras";
    case "IND":
      return "Indien";
    case "IDN":
      return "Indonesien";
    case "IRQ":
      return "Irak";
    case "IRN":
      return "Iran";
    case "IRL":
      return "Irland";
    case "ISL":
      return "Island";
    case "ISR":
      return "Israel";
    case "ITA":
      return "Italien";
    case "JAM":
      return "Jamaika";
    case "JPN":
      return "Japan";
    case "YEM":
      return "Jemen";
    case "JOR":
      return "Jordanien";
    case "KHM":
      return "Kambodscha";
    case "CMR":
      return "Kamerun";
    case "CAN":
      return "Kanada";
    case "CPV":
      return "Kap Verde";
    case "KAZ":
      return "Kasachstan";
    case "QAT":
      return "Katar";
    case "KEN":
      return "Kenia";
    case "KGZ":
      return "Kirgisistan";
    case "KIR":
      return "Kiribati";
    case "COL":
      return "Kolumbien";
    case "COM":
      return "Komoren";
    case "COG":
      return "Kongo";
    case "COD":
      return "Kongo, Demokrat. Republik";
    case "PRK":
      return "Korea, Demokratische Republik";
    case "KOR":
      return "Korea, Republik";
    case "HRV":
      return "Kroatien";
    case "CUB":
      return "Kuba";
    case "KWT":
      return "Kuwait";
    case "LAO":
      return "Laos";
    case "LSO":
      return "Lesotho";
    case "LVA":
      return "Lettland";
    case "LBN":
      return "Libanon";
    case "LBR":
      return "Liberia";
    case "LBY":
      return "Libyen";
    case "LIE":
      return "Liechtenstein";
    case "LTU":
      return "Litauen";
    case "LUX":
      return "Luxemburg";
    case "MDG":
      return "Madagaskar";
    case "MWI":
      return "Malawi";
    case "MYS":
      return "Malaysia";
    case "MDV":
      return "Malediven";
    case "MLI":
      return "Mali";
    case "MLT":
      return "Malta";
    case "MAR":
      return "Marokko";
    case "MHL":
      return "Marshallinseln";
    case "MRT":
      return "Mauretanien";
    case "MUS":
      return "Mauritius";
    case "MEX":
      return "Mexiko";
    case "FSM":
      return "Mikronesien";
    case "MDA":
      return "Moldau";
    case "MCO":
      return "Monaco";
    case "MNG":
      return "Mongolei";
    case "MOZ":
      return "Mosambik";
    case "MMR":
      return "Myanmar";
    case "NAM":
      return "Namibia";
    case "NRU":
      return "Nauru";
    case "NPL":
      return "Nepal";
    case "NZL":
      return "Neuseeland";
    case "NIC":
      return "Nicaragua";
    case "NLD":
      return "Niederlande";
    case "NER":
      return "Niger";
    case "NGA":
      return "Nigeria";
    case "NOR":
      return "Norwegen";
    case "OMN":
      return "Oman";
    case "PAK":
      return "Pakistan";
    case "PLW":
      return "Palau";
    case "PAN":
      return "Panama";
    case "PNG":
      return "Papua-Neuguinea";
    case "PRY":
      return "Paraguay";
    case "PER":
      return "Peru";
    case "PHL":
      return "Philippinen";
    case "POL":
      return "Polen";
    case "PRT":
      return "Portugal";
    case "RWA":
      return "Ruanda";
    case "ROU":
      return "Rumänien";
    case "RUS":
      return "Russland";
    case "WSM":
      return "Samoa";
    case "SAU":
      return "Saudi-Arabien";
    case "SEN":
      return "Senegal";
    case "SRB":
      return "Serbien";
    case "SGP":
      return "Singapur";
    case "SVK":
      return "Slowakei";
    case "SVN":
      return "Slowenien";
    case "ZAF":
      return "Südafrika";
    case "ESP":
      return "Spanien";
    case "LKA":
      return "Sri Lanka";
    case "SDN":
      return "Sudan";
    case "SWE":
      return "Schweden";
    case "CHE":
      return "Schweiz";
    case "TZA":
      return "Tansania";
    case "THA":
      return "Thailand";
    case "TUN":
      return "Tunesien";
    case "TUR":
      return "Türkei";
    case "UGA":
      return "Uganda";
    case "UKR":
      return "Ukraine";
    case "ARE":
      return "Vereinigte Arabische Emirate";
    case "GBR":
      return "Vereinigtes Königreich";
    case "USA":
      return "Vereinigte Staaten";
    case "VEN":
      return "Venezuela";
    case "VNM":
      return "Vietnam";
    case "ZMB":
      return "Sambia";
    case "ZWE":
      return "Simbabwe";
    default:
      return "Unbekanntes Land";
  }
}

export function scrollToTop() {
  document.getElementById("cnc-wp-vue").scrollIntoView();
}

export const isEmpty = (obj) => Object.keys(obj).length === 0;
